import React from "react";
import { FaEdit } from "react-icons/fa";
import EditProfilePhoneNumber from "./EditProfilePhoneNumber";
import Skeleton from "react-loading-skeleton";

const capitalize = (str) =>
  str ? str.charAt(0).toUpperCase() + str.slice(1).toLowerCase() : "";

const ProfilePhoneNumber = ({ userProfile, isLoading, refetch }) => {
  return (
    <>
      <div className="d-flex justify-content-between mb-2">
        <h4 className="small-text font-weight-bold">Phone Numbers: <span style={{ color: '#8e3039' }}>*</span></h4>
        <button
          className="btn btn-outline-primary btn-edit-user-profile"
          data-toggle="modal"
          data-target="#editProfilePhoneNumber"
        >
          <FaEdit size={16} className="mr-2" /> Edit
        </button>
        <EditProfilePhoneNumber
          userProfile={userProfile}
          isLoading={isLoading}
          refetch={refetch}
        />
      </div>
      <div className="row small-text">
        <div className="col-md-6">
          {userProfile?.phones?.map((phone) => (
            <div className="row" key={phone.id}>
              <div className="col-md-4">
                <p>{capitalize(phone.type)} Phone Number:</p>
              </div>
              <div className="col-md-8 d-flex">
                <p className="font-weight-bold">
                  {phone.value}
                  {phone.extension && (
                    <span className="mx-3" style={{ fontSize: "11px" }}>
                     <span className="text-muted">ext. </span><b className="text-black">{phone.extension}</b>
                    </span>
                  )}
                </p>
                {phone.preferred && (
                  <div className="ml-3 badge_pomme bg_primary f-10 text-light rounded-pill d-flex align-items-center justify-content-center">
                    <span>Preferred Contact Number</span>
                  </div>
                )}
              </div>
            </div>
          ))}

          {isLoading && !userProfile && (
            <div className="row">
              <div className="col-md-4"><Skeleton width={120} height={16} /></div>
              <div className="col-md-8"><Skeleton width={160} height={16} /></div>
            </div>
          )}
        </div>
      </div>
      <hr />
    </>
  );
};

export default ProfilePhoneNumber;
